import * as React from "react";

const IconCheckCircle: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#00A65A" d="M7.852 4.602L5.25 7.205 4.127 6.102a.562.562 0 10-.795.795l1.5 1.5c.13.112.273.165.418.165a.559.559 0 00.398-.164l3-3a.562.562 0 10-.796-.796zM6 .5a6 6 0 100 12 6 6 0 100-12zm0 10.875A4.88 4.88 0 011.125 6.5 4.88 4.88 0 016 1.625 4.88 4.88 0 0110.875 6.5 4.88 4.88 0 016 11.375z"/></svg>;
};

export default React.memo(IconCheckCircle);
